import * as XLSX from 'xlsx';
import { trimEmptyColumns, trimEmptyArrays } from './PreviewUtils';

export type DataCell = string | number | null;
export type DataRow = DataCell[];

export interface GenericReportPreviewData {
  sheetName: string;
  table: any[][];
}

export interface GenericReportPreviewServiceInterface {
  getFilePreviewData(fileUrl: string): Promise<GenericReportPreviewData[]>;
}

export class GenericReportPreviewService implements GenericReportPreviewServiceInterface {
  constructor(private keywords: string[] = ['생산', '일지']) {}

  private getSheetData(worksheet: XLSX.WorkSheet, range: XLSX.Range): DataRow[] {
    return XLSX.utils.sheet_to_json(worksheet, { header: 1, range }) as DataRow[];
  }

  async getFilePreviewData(fileUrl: string): Promise<GenericReportPreviewData[]> {
    const response = await fetch(fileUrl);
    if (!response.ok) throw new Error(`Failed to fetch file: ${response.status}`);

    const arrayBuffer = await response.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    console.log(workbook);

    const containsKeyword = (table: any[][]): boolean =>
      table
        .flat()
        .some(
          cell => typeof cell === 'string' && this.keywords.some(keyword => cell.includes(keyword))
        );

    const sheetsToProcess = workbook.SheetNames.filter(sheetName => {
      const worksheet = workbook.Sheets[sheetName];
      const previewTable = this.getSheetData(worksheet, { s: { r: 0, c: 0 }, e: { r: 10, c: 10 } });
      return containsKeyword(previewTable);
    });
    console.log(sheetsToProcess);

    return sheetsToProcess.map(sheetName => {
      const worksheet = workbook.Sheets[sheetName];
      const table = trimEmptyColumns(
        trimEmptyArrays(this.getSheetData(worksheet, { s: { r: 0, c: 0 }, e: { r: 200, c: 50 } }))
      );
      return { sheetName, table };
    });
  }
}
